let env = process.env.REACT_APP_ENV;
let server;

if (env == "production") {
  server = process.env.REACT_APP_SERVER;
} else {
  server = process.env.REACT_APP_SERVER_HML;
}

export default server;
